class BrainTreeController
  @initialize: (form_id) =>
    @form = $("#"+form_id)
    @submitButton = @form.find('input[type="submit"]')
    options = {
      authorization: @form.data('bttoken')
    }
    braintree.client.create(options, @client_created)


  @client_created: (clientErr, clientInstance) =>
    if clientErr
      BrainTreeController.inform clientErr
      return
    
    options = {
      client: clientInstance,
      kount: true
    }
    braintree.dataCollector.create(options, @data_collector_created)

    options = {
      client: clientInstance,
      styles: {
        'input': {
          'font-size': '10pt'
        },
        'input.invalid': {
          'color': 'red'
        },
        'input.valid': {
          'color': 'green'
        }
      },
      fields: {
        number: {
          selector: '#credit_card_number',
          placeholder: '1111 1111 1111 1111'
        },
        cvv: {
          selector: '#credit_card_verification_value',
          placeholder: '111'
        },
        expirationMonth: {
          selector: '#credit_card_exp_month',
          placeholder: 'MM'
        }
        expirationYear: {
          selector: '#credit_card_exp_year',
          placeholder: 'YYYY'
        }
      }
    }
    braintree.hostedFields.create(options, @hosted_fields_created)


  @data_collector_created: (err, dataCollectorInstance) =>
    if (err)
      BrainTreeController.inform clientErr
      return

    deviceDataInput = @form.find('input[name="device_data"]')
    if (deviceDataInput.length == 0)
      deviceDataInput = $('<input>')
      deviceDataInput.attr({
        type: 'hidden',
        id: 'device_data',
        name: 'device_data'
      })
      @form.append(deviceDataInput)

    deviceDataInput.val(dataCollectorInstance.deviceData)


  @hosted_fields_created: (hostedFieldsErr, hostedFieldsInstance) =>
    if hostedFieldsErr
      BrainTreeController.inform hostedFieldsErr
      return

    @hostedFieldsInstance = hostedFieldsInstance
    @submitButton.removeAttr('disabled')
    @form.on('submit', @submit)


  @submit: (event) =>
    event.preventDefault()
    @submitButton.prop("disabled", true)
    @submitButton.val("Please wait ...")
    @hostedFieldsInstance.tokenize(@tokenized)


  @tokenized: (tokenizeErr, payload) =>
    if tokenizeErr
      BrainTreeController.inform tokenizeErr
      return

    $('input[name="payment_method_nonce"]').val(payload.nonce)
    @form[0].submit()


  @inform: (error) =>
    console.error error
    alert error.message
    @submitButton.removeAttr('disabled')
    @submitButton.val("Try again!")


module.exports = BrainTreeController
